var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pt-0 pb-0",staticStyle:{"border":"none"}},[_c('v-card-title',{staticClass:"pl-0 pt-2 font-weight-light",staticStyle:{"position":"relative","left":"-40px"}},[_vm._v(" 12mth National Data Usage ")]),_c('apexchart',{staticClass:"pl-1 pr-1",attrs:{"options":_vm.chartOptions,"series":_vm.series,"height":"320"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }